import { ApplicationConfig} from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { providePrimeNG } from 'primeng/config';
import MyPreset from './mypreset';
import { MessageService } from 'primeng/api';

export const widgetConfig: ApplicationConfig = {
    providers: [
    providePrimeNG({
            theme: {
                preset: MyPreset,
                options: { darkModeSelector: '.app-dark', cssLayer: false },
            },
            ripple: true,
        }),
        provideHttpClient(withInterceptorsFromDi()),
        MessageService
    ],
};

